import translations from './translations.js';
import { SUPPORTED_LANGUAGES, languageFromPath, localePath, pageFromPath } from './routing.mjs';

export const SITE_URL = 'https://picapicabooth.app';
export const EN_HOME_TITLE = 'Picapica Booth — Free Online Photo Booth, No Download';
export const SEO_PAGES = ['/', '/photobooth'];

export function seoForPath(pathname) {
  const language = languageFromPath(pathname);
  const page = pageFromPath(pathname);
  const copy = translations[language];
  const title = page === '/photobooth' ? copy.photoBoothTitle
    : language === 'en' && page === '/' ? EN_HOME_TITLE : `${copy.appName} - ${copy.tagline}`;
  return {
    language,
    title,
    canonical: SITE_URL + localePath(language, page),
    // Only advertise page variants whose static shells are generated.
    alternates: SEO_PAGES.includes(page) ? [
      ...SUPPORTED_LANGUAGES.map(code => ({ language: code, href: SITE_URL + localePath(code, page) })),
      { language: 'x-default', href: SITE_URL + localePath('en', page) }
    ] : []
  };
}

export function syncSeoHead(pathname, doc = document) {
  const seo = seoForPath(pathname);
  doc.documentElement.lang = seo.language;
  // Other pages retain their existing component-specific titles.
  if (SEO_PAGES.includes(pageFromPath(pathname))) doc.title = seo.title;
  const upsert = (selector, tag, attributes) => {
    const elements = [...doc.head.querySelectorAll(selector)];
    const element = elements.shift() || doc.head.appendChild(doc.createElement(tag));
    elements.forEach(duplicate => duplicate.remove());
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
  };
  upsert('link[rel="canonical"]', 'link', { rel: 'canonical', href: seo.canonical });
  doc.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => link.remove());
  seo.alternates.forEach(({ language, href }) => {
    const link = doc.createElement('link');
    Object.entries({ rel: 'alternate', hreflang: language, href }).forEach(([key, value]) => link.setAttribute(key, value));
    doc.head.appendChild(link);
  });
  upsert('meta[property="og:url"]', 'meta', { property: 'og:url', content: seo.canonical });
  upsert('meta[property="og:title"]', 'meta', { property: 'og:title', content: doc.title });
  upsert('meta[name="twitter:title"]', 'meta', { name: 'twitter:title', content: doc.title });
}
